export default __webpack_public_path__ + "static/member4-06da8167ab835692603228a0a9404fe8.jpg";